import angular from "angular";
// import Sentry from "@sentry/browser";
import { HttpNotConfigException } from "../exception/index";
import { envConfig } from "@env/env-config";

export class RestService {

    private SERVICE_CONFIGS: { [name: string]: qpmn.common.rest.IHttpRestConfig };

    private RETRY_MAX_TIME: number;

    private RETRY_TIME_SPAN: number;

    private DEFAULT_HEADERS: angular.IHttpRequestConfigHeaders;

    constructor(
        private $http: angular.IHttpService,
        private $q: angular.IQService,
        private $timeout: angular.ITimeoutService,
        private urlBuilder: qpmn.common.rest.IUrlBuilderService,
        private restRuntime: qpmn.common.rest.IRestRuntime,
        restConfigs: qpmn.common.rest.IRestServiceConfig) {
        this.promiseSuccess = this.promiseSuccess.bind(this);
        this.promiseError = this.promiseError.bind(this);
        this.downloadFileByBlob = this.downloadFileByBlob.bind(this);
        this.readJsonByBlob = this.readJsonByBlob.bind(this);
        this.retryPromise = this.retryPromise.bind(this);
        this.httpRetry.bind(this);

        this.SERVICE_CONFIGS = restConfigs.serviceConfigs;
        this.RETRY_MAX_TIME = restConfigs.retryMaxTime;
        this.RETRY_TIME_SPAN = restConfigs.retryTimeSpan;
        this.DEFAULT_HEADERS = restConfigs.defaultHeaders;
    }

    /**
       * @function restService.promiseSuccess
       * @description 调用promise成功返回时处理
       * 
       * @param {*} event 
       * @param {*} deferred 
       */
    private promiseSuccess<T>(event: qpmn.common.rest.IRestEvent<T>, deferred: angular.IDeferred<qpmn.common.rest.IRestResponse<T>>): void {
        (function (e: qpmn.common.rest.IRestEvent<T>) {
            if (e.success || e.Success || (e.data && (e.data.success || e.data.Success))) {
                deferred.resolve(e.data || e);
            } else {
                // 使用sentry处理200类型错误
                // Sentry.withScope(this.sentryService.getScope("RESTFUL_RESOLVE", function (scope) {
                //     Sentry.captureException(e);
                // }));
                deferred.reject(e);
            }
        })(event);
    }

    /**
     * @function restService.promiseError
     * @description 调用promise失败时处理
     * 
     * @param {*} event 
     * @param {*} deferred 
     */
    private promiseError<T>(event: qpmn.common.rest.IRestEvent<T>, deferred: angular.IDeferred<qpmn.common.rest.IRestResponse<T>>): void {
        // // 抓取请求失败错误手动发送sentry
        // Sentry.withScope(this.sentryService.getScope("RESTFUL_REJECT", function (scope) {
        //     Sentry.captureException(event);
        // }));

        (function (e) {
            deferred.reject(e);
        })(event);
    }

    /**
     * 通过Blob下载文件
     * @param {*} event 
     */
    private downloadFileByBlob(event: angular.IHttpResponse<any>) {
        let blob = new Blob([event.data], {
            type: event.data.type
        });
        let reader = new FileReader();
        reader.readAsBinaryString(blob);

        let downloadElement = document.createElement('a');
        downloadElement.href = window.URL.createObjectURL(blob);

        let fileName = "";
        //服务器返回了指定文件名
        if (event.headers("content-disposition") && /filename=([\w-.]*)/i.test(event.headers("content-disposition"))) {
            let names = event.headers("content-disposition").match(/filename=([\w-.]*)/i);

            if (names && names.length > 1) {
                fileName = names[1];
            }
        }

        //如果服务器没有指定文件名，则生成时间有关的随机名称
        if (fileName == "") {
            let now = new Date();
            let fileFormat = "txt";
            let formats = event.headers("content-type").match(/(application|image)\/([\w]*);/i)
            if (formats && formats.length > 2) {
                fileFormat = formats[2];
            }

            fileName = now.getFullYear().toString() + "-" + (now.getMonth() + 1).toString() + "-" + now.getDate() + "_" + Math.random() * 10000 + "." + fileFormat;
        }

        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        downloadElement.remove();
        window.URL.revokeObjectURL(downloadElement.href);
    }

    /**
     * 通过Blob读取JSON对象
     * @param {*} event 
     */
    private readJsonByBlob(event: angular.IHttpResponse<any>, callback?: Function) {
        let blob = new Blob([event.data], {
            type: event.data.type
        });
        let reader = new FileReader();
        reader.readAsBinaryString(blob);

        reader.onload = function () {
            //是否需要retry
            let result = reader.result as string;
            let resultToJson = JSON.parse(result);
            callback && callback(resultToJson);
        }
    }

    /**
     * @function restService.promiseRetry
     * @description 调用promise成功返回时处理
     * @param {*} obj 
     * @param {*} excuteTimes 
     * @param {*} event 
     * @param {*} deferred 
     * @param {*} retryFunc 
     */
    private retryPromise<T>(obj: angular.IRequestConfig, event: qpmn.common.rest.IRestEvent<T>, deferred: angular.IDeferred<qpmn.common.rest.IRestResponse<T>>, retryParameter: qpmn.common.rest.IRetryParameter) {
        if (event.success || event.Success || (event.data && (event.data.success || event.data.Success))) {
            //需要重试
            if (retryParameter.needRetry || event.needRetry || event.data.needRetry) {
                //未达到重试次数上限
                if (retryParameter.retryMaxtime && retryParameter.retryMaxtime >= retryParameter.excuteTimes) {
                    this.$timeout(function () {
                        retryParameter.excuteTimes + 1;
                        retryParameter.retryFunc(obj, deferred, retryParameter);
                    }, retryParameter.retryTimeSpan)
                } else {
                    //达到重试次数上限
                    this.promiseError(event, deferred,);
                    // 通知用户并询问是否重试
                }
            } else {
                this.promiseSuccess(event, deferred);
            }
        } else {
            // // 使用sentry处理200类型错误
            // Sentry.withScope(this.sentryService.getScope("RESTFUL_RESOLVE", function (scope) {
            //     Sentry.captureException(event);
            // }));
            this.promiseError(event, deferred);
            // 通知用户,系统错误
        }
    }

    /**
     * @function restService.httpRetry
     * @description 生成http请求的Promise
     * 
     * @param {*} obj 
     * @param {Number} excuteTimes
     * @param {*} deferred 
     * @param {*} successFunc 
     * @param {*} errorFunc 
     */
    private httpRetry<T>(httpConfig: angular.IRequestConfig, deferred: angular.IDeferred<qpmn.common.rest.IRestResponse<T>>, retryParameter: qpmn.common.rest.IRetryParameter) {
        this.$http(httpConfig).then(
            //成功返回处理函数
            function (event: qpmn.common.rest.IRestEvent<T>) {
                // TODO blob代表什么
                if (event && event.config && event.config.responseType === "blob") {
                    if (/(application\/json)/i.test(event.headers("content-type"))) {
                        this.readJsonByBlob(event, function (data) {
                            event.data = data;
                            this.retryPromise(httpConfig, event, deferred, retryParameter);
                        });
                    } else {
                        this.downloadFileByBlob(event);
                        this.promiseSuccess(event, deferred);
                    }
                } else {
                    this.retryPromise(httpConfig, event, deferred, retryParameter);
                }
            }.bind(this),
            //调用失败时的处理函数
            function (event) {
                this.promiseError(event, deferred);
            }.bind(this));
    }

    /**
     * http请求
     * @function restService.http
     * @param serviceName 
     * @param functionName 
     * @param data 
     * @returns 
     */
    public http<T>(serviceName: string, functionName: string, data?: any, headers?: angular.IHttpRequestConfigHeaders): angular.IPromise<qpmn.common.rest.IRestResponse<T>> {

        //http请求的配置对象
        let cfg = this.SERVICE_CONFIGS[serviceName + "__" + functionName];
        if (!cfg) {
            throw new HttpNotConfigException(serviceName + "__" + functionName);
        }

        //构建URL参数
        let path = this.restRuntime.useTestVersion && cfg.testPath ? cfg.testPath : cfg.path;

        if (cfg.paramDefaults && data) {
            path = this.urlBuilder.setUrlParams(path, cfg.paramDefaults, data);
        }

        const hasStage = envConfig.appPath();

        let url = this.urlBuilder.joinUrl([hasStage, cfg.appPath, path]);

        //构建$http参数
        let httpCfg: angular.IRequestConfig = {
            url: url,
            method: cfg.method,
            headers: angular.extend(angular.copy(this.DEFAULT_HEADERS), headers),
            data: data
        };

        if (cfg.requestConfig) {
            angular.merge(httpCfg, cfg.requestConfig);
        }

        //是否需要认证
        if (cfg.isAuth !== false && this.restRuntime.token) {
            angular.merge(httpCfg, {
                "headers": {
                    "Authorization": this.restRuntime.token.token_type + " " + this.restRuntime.token.access_token
                }
            });
        }

        let deferred = this.$q.defer<qpmn.common.rest.IRestResponse<T>>();

        let retryParameter: qpmn.common.rest.IRetryParameter = {
            excuteTimes: 0,
            retryFunc: this.httpRetry.bind(this)
        };

        if (cfg.needRetry) {
            retryParameter.needRetry = true;
            retryParameter.retryMaxtime = cfg.retryMaxtime || this.RETRY_MAX_TIME;
            retryParameter.retryTimeSpan = cfg.retryTimeSpan || this.RETRY_TIME_SPAN;
        } else {
            retryParameter.retryMaxtime = this.RETRY_MAX_TIME;
            retryParameter.retryTimeSpan = this.RETRY_TIME_SPAN;
        }

        this.httpRetry(httpCfg, deferred, retryParameter);

        return deferred.promise;
    }

    // public resource<T>(parameter: IRestParameter, successFunction?: (event: IRestEvent, def: angular.IDeferred<IRestResponse>) => void, errorFunction?: (event: IRestEvent, def: angular.IDeferred<IRestResponse>) => void): angular.IPromise<T> {
    //     throw new Error("resource is developing");
    // }
}